import { render, staticRenderFns } from "./PbxDetails.vue?vue&type=template&id=0458debe&"
import script from "./PbxDetails.vue?vue&type=script&lang=js&"
export * from "./PbxDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports